import { Component, OnInit, ViewChild } from '@angular/core';
import { FuseAlertType } from '../../../../../@fuse/components/alert';
import { NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../core/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-all-devices-logout-dialog',
  templateUrl: './all-devices-logout-dialog.component.html',
  styleUrls: ['./all-devices-logout-dialog.component.scss'],
})
export class AllDevicesLogoutDialogComponent implements OnInit {
  showAlert: boolean = false;
  alert: { type: FuseAlertType; message: string } = {
    type: 'success',
    message: '',
  };

  attempts: number = 0;
  logoutForm: UntypedFormGroup;
  @ViewChild('logoutNgForm') logoutNgForm: NgForm;
  hideForm: boolean;
  isUploadingInProgress: boolean = false;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _authService: AuthService,
    private _router: Router,
    private _toaster: ToastrService,
    public dialogRef: MatDialogRef<AllDevicesLogoutDialogComponent>,
    private translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    this.logoutForm = this._formBuilder.group({
      password: ['', Validators.required],
    });
    this.attempts = parseInt(this._authService.logoutAttempts);
  }

  logout() {
    // Return if the form is invalid
    if (this.logoutForm.invalid) {
      return;
    }

    // Disable the form
    this.logoutForm.disable();

    // Hide the alert
    this.showAlert = false;

    const LOGOUT_ALL_TIMEOUT_MS = 30000; // Prevent stuck UI for slow V1 API (PC-1632)
    const timeoutPromise = new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('Logout timeout')), LOGOUT_ALL_TIMEOUT_MS),
    );

    Promise.race([this._authService.logOutAllDevices(this.logoutForm.value), timeoutPromise])
      .then((res) => {
        // Clear token and reload so user is not left authenticated (fixes redirect loop to /projects/all_projects for V1 users - PC-1632)
        this._authService.clearLocalAuthAndReload();
      })
      .catch((error) => {
        if (error?.message === 'Logout timeout') {
          this._authService.clearLocalAuthAndReload();
          return;
        }
        // check if 'Uploading report in progress'
        if (error?.error?.error_code === 'LOGOUT_001') {
          // Set the alert
          this.alert = {
            type: 'error',
            message: error?.error?.message,
          };
          // Show the alert
          this.showAlert = true;
          this.isUploadingInProgress = true;
          this.logoutForm.enable();
        } else {
          //count attempts
          this.attempts--;
          this._authService.logoutAttempts = this.attempts.toString();
          if (this.attempts === 0) {
            this._authService.clearLocalAuthAndReload();
          } else if (this.attempts === 1) {
            // Set the alert
            this.alert = {
              type: 'error',
              message: this.translocoService.translate(
                "You have 1 Attempts left,then you'll only be logged out from the current device",
              ),
            };
            this.logoutForm.enable();
            // Reset the form
            this.logoutNgForm.resetForm();
            // Show the alert
            this.showAlert = true;
          } else {
            this.logoutForm.enable();
            // Reset the form
            this.logoutNgForm.resetForm();

            // Set the alert
            this.alert = {
              type: 'error',
              message: error?.error?.message,
              // 'Wrong password'
            };
            // Show the alert
            this.showAlert = true;
          }
        }
      });
  }

  onDismiss() {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
